import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiTrash } from "react-icons/bi"; 
import { BiSave } from "react-icons/bi"; 
import React from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxSearcher from '../../cx/CxSearcher';
import CxInput from '../../cx/CxInput';
import CxFile from '../../cx/CxFile';
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxSnackbar from '../../cx/CxSnackbar';
import CxDialog from '../../cx/CxDialog';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFile from '../../fx/FxFile';
import * as FxFetch from '../../fx/FxFetch';
import { getStoreValue, StoreSettCertificate } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettCertificateForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_form = React.useRef(null);
  
  const [inBranch, ] = React.useState(getStoreValue('StoreSession', 'inBranch'));
  const [disabledEmployee, setDisabledEmployee] = React.useState(false);
  const [dlgDelete, setDlgDelete] = React.useState(false);

  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);
  const r_snack_save = React.useRef(null);

  const [storeSettCertificate, setStoreSettCertificate] = useSessionStorage('StoreSettCertificate', StoreSettCertificate);

  const rf_txEmployee = React.useRef(null);
  const rf_file = React.useRef(null);
  const rf_pwd = React.useRef(null);

  React.useEffect(() => {
    if (storeSettCertificate.certificateType==='B') {
      Promise.all([FxFetch.doJsonX("general/r",
        { table: 't_certificate', field: 'itCertificate', where: `txLinkCertTable='n_branch' and txLinkCertId='${inBranch}'` }
      )]).then((result) => {
        if (result[0]) {
          storeSettCertificate.itCertificate = result[0].theValue;
          Promise.all([setStoreSettCertificate(storeSettCertificate)]).then((result) => {
            formLoadCustom();
          });
        }
      });
    }

    if (storeSettCertificate.certificateType==='E') {
      formLoadCustom();
    }

    // eslint-disable-next-line
  }, []);
  
  const formLoadCustom = async () => {
    if (!storeSettCertificate.itCertificate) { //nuevo registro

    } else {
      let record = {};
      record['itCertificate'] = storeSettCertificate.itCertificate;
      //FxLog.infox('MxSettCertificateForm.formLoadCustom', '...storeSettCertificate.itCertificate:', storeSettCertificate.itCertificate);
      Promise.all([FxFetch.doJsonX('sett/certificate/r', record)]).then((result) => {
        if (result[0]) {
          if (storeSettCertificate.certificateType==='E') {
            rf_txEmployee.current.setKey(result[0].inEmployee);
            rf_txEmployee.current.setVal(result[0].txEmployee);
            setDisabledEmployee(true);
          }

          let base64File = result[0].obCertFile;
          let fileName = result[0].txCertFileName;
          let password = result[0].txCertPwd;
          if (base64File) {
            Promise.all([FxFile.getFileFromBase64(base64File, fileName, 'application/x-pkcs12')]).then((result) => {
              let file = result[0];
              if (file) {
                rf_file.current.setFile(file);
                rf_file.current.setFileName(file.name);
                rf_pwd.current.setVal(password);
              }
            });
          }
        }
      });
    }
  }
  const formSaveCustom = async () => {
    FxLog.infox('MxSettCertificateForm.formSaveCustom', '...:', );
    let inEmployee = ((storeSettCertificate.certificateType==='E') ? rf_txEmployee.current.getKey() : '');
    let file = rf_file.current.getFile();
    let pin = rf_pwd.current.getVal();
    if ((storeSettCertificate.certificateType==='E' && !inEmployee) || !file || !pin) {
      if (storeSettCertificate.certificateType==='E' && !inEmployee) {
        r_snack_required.current.setValAndOpen(trans('field.required') + ": " + trans('field.employee'));
        return;
      }
      if (!file) {
        r_snack_required.current.setValAndOpen(trans('field.required') + ": " + trans('field.multimedia_file'));
        return;
      }
      if (!pin) {
        r_snack_required.current.setValAndOpen(trans('field.required') + ": " + trans('field.password'));
        return;
      }
      
    } else {
      Promise.all([FxFile.getBase64FromFile(file)]).then((result) => {
        const base64KeyStore = result[0].replace('data:application/x-pkcs12;base64,', '');
        let filter = {};
        filter['itCertificate'] = storeSettCertificate.itCertificate;
        let record = {};
        if (storeSettCertificate.certificateType==='B') {
          record['inBranch'] = inBranch;
        }
        if (storeSettCertificate.certificateType==='E') {
          record['inEmployee'] = inEmployee;
        }
        record['txCertFileName'] = file.name;
        record['txCertPwd'] = pin;
        record['base64'] = base64KeyStore;
        Promise.all([FxFetch.doJsonF('sett/certificate/cu', filter, record)]).then((result) => {
          if (result[0]) {
            if (result[0].theValue === "rv_exists") {
              r_snack_exists.current.setOpen(true);
            } else {
              if (result[0].theStatus === 'OK') {
                FxLog.infox('MxSettCertificateForm.formSaveCustom', '...result[0]:', result[0]);
                storeSettCertificate.itCertificate = result[0].theValue;
                Promise.all([setStoreSettCertificate(storeSettCertificate)]).then((result) => {
                  r_snack_save.current.setOpen(true);
                });
              }
            }
          }
        });
      });
    }
  }

  const doDelete = async () => {
    let record = {};
    record['idValue'] = storeSettCertificate.itCertificate;
    Promise.all([FxFetch.doJsonX('sett/certificate/d', record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          navBack();
        }
      }
    });
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.certificate')} - ${storeSettCertificate.title}`}
        xref={r_form}
        saveAndExit
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {/* botón borrar */}
            <CxIconButtonNew icon={<BiTrash/>} classType="ibs_iconbutton_toolbar" onClick={() => setDlgDelete(true)} tooltip={trans('field.delete')} />

            {/* botón guardar */}
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >

        {storeSettCertificate.certificateType==='E' && <CxSearcher xref={rf_txEmployee} label={trans('field.employee')}
          url="employees" col_id="inEmployee" col_tx="txEmployee"
          tooltip={`${trans('field.employee')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inEmployee", show: false },
            { id: "1", Header: trans('field.employee'), accessor: row => rf_txEmployee.current.getTable().highlightText(row["txEmployee"]), width: '100%' },
          ]}
          disabled={disabledEmployee}
          required
        />}
        
        <CxFile xref={rf_file} label={trans('field.multimedia_file')}
          width='var(--ibs_control_width_md)'
          required
        />

        <CxInput xref={rf_pwd} label={trans('field.password')} 
          type="password"
          width='var(--ibs_control_width_md)'
          required
        />

      </GxForm>

      <CxDialog title={trans('msg.warning')} open={dlgDelete}
        onCancel={() => setDlgDelete(false)}
        onOk={() => { 
          setDlgDelete(false); 
          doDelete() 
        }}
        height='200px'>
        {trans('msg.ask_delete')}
      </CxDialog>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" value={trans('msg.x_exists', 'field.certificate')} />
      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />

    </div>
  );

}

export default MxSettCertificateForm;
